import React from 'react';
import PropTypes from 'prop-types';
import { Box, CloseButton, Flex, useColorModeValue } from '@chakra-ui/react';
import NavItem from 'components/Layout/NavItem';
import Logo from 'components/Layout/Logo';

const SidebarContent = ({ linkItems, onClose, ...rest }) => {
  return (
    <Box
      transition="3s ease"
      bg={useColorModeValue('white', 'gray.900')}
      borderRight="1px"
      borderRightColor={useColorModeValue('gray.200', 'gray.700')}
      w={{ base: 'full', md: 60 }}
      pos="fixed"
      h="full"
      {...rest}
    >
      <Flex h="20" alignItems="center" mx="8" justifyContent="space-between">
        <Logo />
        <CloseButton display={{ base: 'flex', md: 'none' }} onClick={onClose} />
      </Flex>
      {linkItems.map(link => (
        <NavItem key={link.name} {...link}>
          {link.name}
        </NavItem>
      ))}
    </Box>
  );
};

SidebarContent.propTypes = {
  onClose: PropTypes.func.isRequired,
  linkItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      to: PropTypes.string,
      icon: PropTypes.func,
    }).isRequired
  ),
};

SidebarContent.defaultTypes = {};

export default SidebarContent;
